import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { hasAdminAccessFeature } from '../util/accessControl'
import {
    selectAllFeatures,
    selectUserSubscriptionPlans,
    selectUserSubscriptionPlansData,
} from '../selectors/user'
import { PremiumFeature } from '../proto/generated/subscription'

/** True when the user's subscription includes ADMIN_ACCESS (by feature code). */
export const useHasAdminAccess = (): boolean => {
    const allFeatures = useSelector(selectAllFeatures)
    const planIds = useSelector(selectUserSubscriptionPlans)
    const plansById = useSelector(selectUserSubscriptionPlansData)

    return useMemo(() => {
        const userFeatures: PremiumFeature[] | undefined =
            !planIds?.length || !plansById
                ? undefined
                : planIds.flatMap((plan) => plansById[plan] ?? [])
        return hasAdminAccessFeature(allFeatures, userFeatures)
    }, [allFeatures, planIds, plansById])
}
